export enum DASHBOARD_TITLES {
  /* ONE ENTRY WHERE THERE WERE FOUR. Home, Analytics, Reports and
     View/Edit/Export are one screen now — see the header of
     components/pages/dashboard/dashboard-screen/dashboard-screen.tsx. It keeps the
     `home` slug because that is what /dashboard resolves to and what the
     sidebar's own logo links at; the slug is an internal key, the label is the
     word the reader sees. */
  HOME = 'Dashboard',
  BUILDINGS = 'Buildings',
  PORTFOLIOS = 'Portfolios',
  UNITS = 'Units',
  USERS = 'Users',
  STAFF_ACCESS = 'Staff Access',
  SHIFTS = 'Shifts',
  /* The ENUM KEY stays TENANTS — it is referenced by slug across the nav, the
     route table and the section resolver, and renaming a key to change a word
     on screen is a refactor bought with nothing. The VALUE is what a person
     reads, and the product retired 'tenant' in favour of 'resident' when
     migration 037 made residency an occupancy rather than a role
     (src/auth/roles.ts records the rename; ROLE_LABELS already says Resident).
     The nav was the last place still saying the old word. */
  TENANTS = 'Residents',
  /* KEPT, AND NO LONGER IN THE MENU. Both are still reachable as URLs — an old
     bookmark or an emailed link must not 404 — and both now render the Command
     Center. The constants stay so the titles a saved link resolves to are still
     defined; deleting them would make `dashboardTitleForPath` fall through to
     the default for a route that still exists. */
  ANALYTICS = 'Analytics',
  REPORTS = 'Reports',
  BILLING = 'Billing',
  /* Resident-portal Plan 3 (RP-3.7): the register of every pass at a building,
     and the building's on/off switch. RP-D11's label. */
  VISITOR_PASSES = 'Visitor passes',
  /* Lobbero Stays (ai-plans/stays plan S1): units listed for short-term guests. */
  STAYS = 'Stays',
}

// DASHBOARD = 'Dashboard',
